const Hero = () => {
  return (
    <section className="hero" aria-label="Introduction">
      <div className="hero__left">
        <p className="hero__eyebrow">London's Trusted Pavers</p>
        <h1 className="hero__title">
          Crafted for
          <br />
          the <em>long haul.</em>
        </h1>
        <p className="hero__sub">
          PaveMend transforms outdoor spaces across SE London: Sidcup, Lewisham,
          Bromley, Greenwich, Orpington and beyond — precision-laid driveways,
          stunning patios, beautiful decking and solid fencing, built to endure
          and designed to impress.
        </p>
        <div className="hero__btns">
          <a href="/booking" className="btn-primary">
            Free Quote
          </a>
          <a href="/#services" className="btn-secondary">
            Our Services
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
        </div>
      </div>

      <div className="hero__right" aria-hidden="true">
        <div className="hero__pattern"></div>
        <div className="hero__badge">
          <div className="hero__badge-logo">
            <span className="p">P</span>
            <span className="m">M</span>
          </div>
          <p className="hero__badge-title">
            PAVE<span>MEND</span>
          </p>
          <p className="hero__badge-tagline">
            South East London & surrounding areas
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
